module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part_number"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#p01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "part_title"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#p01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ascension!")])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("‘To worship me take wine and strange drugs whereof I will tell my prophet, & be drunk thereof!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("They shall not harm thee at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('strong', [_vm._v("– Aleister Crowley, "), _c('em', [_vm._v("The Book of the Law")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18873f0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/p01.vue
// module id = 78
// module chunks = 0